import _ from 'lodash'

export function serializeQuickAction(data) {
  const {
    name,
    categories = [],
    location = {},
    team = {},
    beforePhase = {},
    afterPhase = {},
    reviewPhase = {},
    challenge,
    completedBy = {},
    priority,
    dueDate,
    lang,
    notes,
    status,
    canceledReason,
    onHoldReason,
    impactStartsAt,
    impactEndsAt,
  } = data

  const quickAction = {
    name,
    notes,
    categories,
    location: serializeLocation(location),
    team: serializeTeam(team),
    beforePhase: serializeBeforePhase(beforePhase),
    afterPhase: serializeAfterPhase(afterPhase),
    reviewPhase: serializeReviewPhase(reviewPhase),
    completedBy: serializeCompletedAuthor(completedBy),
    priority,
    dueDate,
    lang,
    status,
    canceledReason,
    onHoldReason,
    impactStartsAt,
    impactEndsAt,
  }

  if (!_.isUndefined(challenge)) {
    quickAction.challenge = serializeChallenge(challenge)
  }

  return quickAction
}

function serializeCompletedAuthor(completedBy) {
  return _.get(completedBy, 'id', null)
}

function serializeLocation(location) {
  const { site, tags = [] } = location
  return {
    site: _.get(site, '_id') || site,
    tags: tags.map(t => t._id || t),
  }
}

function serializeTeam(team) {
  const collaborators = _.get(team, 'collaborators') || []
  const serializedTeam = {
    coach: _.get(team, 'coach._id', ''),
    collaborators: collaborators.map(c => c._id),
    owner: _.get(team, 'owner._id', ''),
  }

  return _.omitBy(serializedTeam, _.isEmpty)
}

function serializeBeforePhase(beforePhase = {}) {
  const situationMedia = _.get(beforePhase, 'media') || []

  return {
    situation: _.get(beforePhase, 'situation', ''),
    media: situationMedia.map(m => m.id),
    situationTypes: _.get(beforePhase, 'situationTypes', []),
  }
}

function serializeAfterPhase(afterPhase) {
  const solutionMedia = _.get(afterPhase, 'media') || []

  const serializedAfterPhase = {
    solution: _.get(afterPhase, 'solution', ''),
    media: solutionMedia.map(m => m.id),
    suggestedTags: _.get(afterPhase, 'suggestedTags', []),
  }

  return serializedAfterPhase
}

function serializeReviewPhase(reviewPhase = {}) {
  const {
    estimationExplanation = '',
    impacts = [],
    investments = [],
  } = reviewPhase
  const costReduction = _.get(reviewPhase, 'costReduction.capturedValue', null)
  const investment = _.get(reviewPhase, 'investment.capturedValue', null)
  const timeTracking = reviewPhase?.timeTracking ?? {
    timeReductionByMonth: null,
    timeInvested: null,
  }

  const serializedReview = {
    estimationExplanation,
    timeTracking,
    impacts,
    investments,
  }

  if (costReduction !== null) {
    _.set(
      serializedReview,
      'costReduction.capturedValue',
      String(costReduction)
    )
  }

  if (investment !== null) {
    _.set(serializedReview, 'investment.capturedValue', String(investment))
  }

  return serializedReview
}

function serializeChallenge(challenge) {
  if (challenge) return challenge.id
  return null
}
